"use strict";
exports.__esModule = true;
exports.DEFAULT_PAYMENT_FAILURE = void 0;
exports.DEFAULT_PAYMENT_FAILURE = {
    RENT_TRACKER: {
        MAIN_TEXT: 'Your 1st payment failed ',
        SUB_TEXT: 'There was an issue with your card or bank. Update your card and complete your payment by {{retryDay}} to use Flex this month.',
        CTA: 'Update card'
    },
    SERVICE_ISSUE_SCREEN: {
        BOLD_MAIN_TEXT: 'To use Flex this month, update your card by {{retryTime}} ET on {{retryDay}}, so we can try to process the payment again.',
        MAIN_TEXT: 'We couldn’t complete your payment of {{paymentAmount}} due to an issue with your card or bank.',
        SECOND_TEXT: 'If you think the transaction should have completed, you can try contacting your card issuer to see if they can resolve the issue. You can also make a manual payment now.',
        HEADER: 'Your 1st payment failed',
        PRIMARY_CTA_TEXT: 'Pay now',
        SECONDARY_CTA_TEXT: 'Update card'
    }
};
